import * as React from 'react';
import { Grid } from '@material-ui/core';
import TipoRecoleccion, { ITipoRecoleccion } from "./TipoRecoleccion";
import { useEffect, useState } from "react";
import { enums } from "../../enums/enums";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';

interface IProps {
    value?: number
    recoleccion: IRecoleccion
    mostrarResidencial: boolean
    onClick: (tipoUbicacionId: number) => void
    esOrigen: boolean
    ayuda?: IHelp,
    idiomaId: string
    mostrarSoloTipos?: number[]
}

const TipoRecoleccionLista = ({ value, recoleccion, mostrarResidencial, onClick, esOrigen, ayuda, idiomaId, mostrarSoloTipos }: IProps) => {
    const [noTieneAreaServicio, setNoTieneAreaServicio] = useState(false); 
    const [tiposRecoleccion, setTiposRecoleccion] = useState<ITipoRecoleccion[]>([
        {
            id: 1,
            nombre: traducirLabel(43), // "Comercial",
            descripcion: traducirLabel(188), // "Negocio o Industrial",
            icono: "icon-negocio.png",
            seleccionado: false
        },
        {
            id: 2,
            nombre: traducirLabel(324), // "Residencial",
            descripcion: traducirLabel(326), // "Casa Habitación",
            icono: "icon-home2.png",
            seleccionado: false
        },
        {
            id: 3,
            nombre: traducirMessage(207), // "Ocurre en Sucursal",
            descripcion: esOrigen ? traducirLabel(77) /* "Deja tu mercancía en sucursal Almex" */ : traducirMessage(229) /* "Recoge tu mercancía en sucursal Almex" */,
            icono: "icon-business.png",
            seleccionado: false
        },
    ]);

    useEffect(() => {      
        let tipos: ITipoRecoleccion[] = [{
            id: 1,
            nombre: traducirLabel(43), // "Comercial",
            descripcion: traducirLabel(188), // "Negocio o Industrial",
            icono: "icon-negocio.png",
            seleccionado: false
        },
        {
            id: 2,
            nombre: traducirLabel(324), // "Residencial",
            descripcion: traducirLabel(326), // "Casa Habitación",
            icono: "icon-home2.png",
            seleccionado: false
        },
        {
            id: 3,
            nombre: traducirMessage(207), // "Ocurre en Sucursal",
            descripcion: esOrigen ? traducirLabel(77) /* "Deja tu mercancía en sucursal Almex" */ : traducirMessage(229) /* "Recoge tu mercancía en sucursal Almex" */,
            icono: "icon-business.png",
            seleccionado: false
        }];
        const copiaUbicaciones = (mostrarSoloTipos) ? tipos.filter( (element, index, array) => { return mostrarSoloTipos.includes(element.id) } ) : [...tipos];            
        copiaUbicaciones.forEach(l => l.seleccionado = l.id === value);
        setTiposRecoleccion(copiaUbicaciones);
        if(recoleccion.areaServicio?.id == 0 || recoleccion.areaServicio == undefined)
        {
            setNoTieneAreaServicio(true);
        }
    }, [localStorage.getItem("idioma")] );


    useEffect(() => {
        let tipos: ITipoRecoleccion[] = [{
            id: 1,
            nombre: traducirLabel(43), // "Comercial",
            descripcion: traducirLabel(188), // "Negocio o Industrial",
            icono: "icon-negocio.png",
            seleccionado: false
        },
        {
            id: 2,
            nombre: traducirLabel(324), // "Residencial",
            descripcion: traducirLabel(326), // "Casa Habitación",
            icono: "icon-home2.png",
            seleccionado: false
        },
        {
            id: 3,
            nombre: traducirMessage(207), // "Ocurre en Sucursal",
            descripcion: esOrigen ? traducirLabel(77) /* "Deja tu mercancía en sucursal Almex" */ : traducirMessage(229) /* "Recoge tu mercancía en sucursal Almex" */,
            icono: "icon-business.png",
            seleccionado: false
        }];
        const copiaUbicaciones: ITipoRecoleccion[] = (mostrarSoloTipos) ? tipos.filter( (element, index, array) => { return mostrarSoloTipos.includes(element.id) } ) :[...tipos];
        copiaUbicaciones.forEach(l => l.seleccionado = l.id === value);
        setTiposRecoleccion(copiaUbicaciones);
        if(recoleccion.areaServicio?.id == 0 || recoleccion.areaServicio == undefined)
        {
            setNoTieneAreaServicio(true);
        }
    }, [value]);

    return (<>
        {tiposRecoleccion.map(t => {
            return (
                (!noTieneAreaServicio || t.id === enums.tipoRecoleccion.ocurre || (noTieneAreaServicio && recoleccion.esServicioInternacional)) &&
                (noTieneAreaServicio || mostrarResidencial || t.id !== enums.tipoRecoleccion.residencial) &&
                <Grid key={t.id} item xs={12} sm={6} md={4}>
                    <TipoRecoleccion tipoRecoleccion={t} onClick={() => onClick(t.id)} esOrigen={esOrigen} ayuda={ayuda} />
                </Grid>);
        })}
    </>)
};

export default TipoRecoleccionLista;
